import type { Store } from '@reduxjs/toolkit'

import { connectCastSyncer } from './CastSyncer'
import { connectFileMetadataSyncer } from './FileMetadataSyncer'
import { connectJobChangesSyncer } from './JobChangesSyncer'
import { connectTimelineChunkSyncer } from './TimelineChunkSyncer'

export const connectSyncers = (store: Store) => {
    connectJobChangesSyncer(store)
    connectTimelineChunkSyncer(store)
    connectFileMetadataSyncer(store)
    connectCastSyncer(store)
}
